/**
 * @fileoverview POST handler for the "/engagement/in_app_message_color_profiles/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementInAppMessageColorProfilesUpdateTagsCacheKeys } from "./constants";
import type {
  PostEngagementInAppMessageColorProfilesUpdateTagsProps,
  EngagementInAppMessageColorProfilesUpdateTagsResult,
} from "./types";

export const postEngagementInAppMessageColorProfilesUpdateTags = reactQueryMutationAdapter(
  engagementInAppMessageColorProfilesUpdateTagsCacheKeys,
  ({
    undo_identifier,
    desired_state,
  }: PostEngagementInAppMessageColorProfilesUpdateTagsProps): Promise<EngagementInAppMessageColorProfilesUpdateTagsResult> => {
    return fetch("/engagement/in_app_message_color_profiles/update_tags", "POST", {
      undo_identifier,
      desired_state,
    });
  }
);
